import { useContext } from 'preact/hooks';
import { IntlContext, Translations } from '../lib/i18n/i18n-context';

function getNestedValue(obj: Translations, key: string): string | Translations | undefined {
  const keys = key.split('.');
  let current: string | Translations | undefined = obj;
  for (const k of keys) {
    if (
      typeof current !== 'object' ||
      current === null ||
      !Object.prototype.hasOwnProperty.call(current, k)
    ) {
      return undefined;
    }
    current = (current as Translations)[k];
  }
  return current;
}

export const useTranslation = () => {
  const context = useContext(IntlContext);
  if (!context) {
    throw new Error('useTranslations must be used within a LightIntlProvider');
  }
  const { translations } = context;
  const t = (key: string, params?: Record<string, string | number>): string => {
    const value = getNestedValue(translations, key);

    if (typeof value === 'string') {
      let result = value;
      if (params) {
        for (const paramKey in params) {
          result = result.replace(new RegExp(`{{${paramKey}}}`, 'g'), String(params[paramKey]));
        }
      }
      return result;
    }

    console.warn(`Translation key "${key}" not found or not a string.`);
    return `[${key}]`;
  };

  return { t, translations };
};
